var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.tokensPerHour > 0)?_c('div',{staticClass:"d-flex align-center",style:({
			color: 'var(--grey-500)',
			fontSize: '12px',
			lineHeight: '1.2',
		})},[(_vm.showPrefix)?_c('span',[_vm._v("or  ")]):_vm._e(),_c('tokens-s-v-g',{staticStyle:{"margin":"0 2px 0 0"},attrs:{"fill":"var(--grey-500)","width":_vm.iconSize,"height":_vm.iconSize}}),_c('b',[_vm._v(_vm._s(_vm._f("currencyTokens")(_vm._f("hundredthsToTokens")(_vm.tokensPerHour)))+" "+_vm._s(_vm._f("pluralize")('token',_vm.tokensPerHour)))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }